var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.4033 10L19.9033 5.5L15.4033 1","stroke":"black","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M19.875 5.47192L-0.000528812 5.47192","stroke":"black","strokeLinejoin":"round","key":1})]);
}

ArrowInline.defaultProps = {"width":"21","height":"11","viewBox":"0 0 21 11","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
